import React, { Component } from "react";
import { connect } from "react-redux";
import produce from "immer";
import _ from "lodash";
import ModifyCCode from "./ModifyCCode";

class Stranger extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showStranger: false
    };
  }

  toggleStranger = () => {
    this.setState(
      produce(draft => {
        draft.showStranger = !draft.showStranger;
      })
    );
  };

  renderRow = () => {
    const { users, cCodes } = this.props;

    return (
      <table className="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">이름</th>
            <th scope="col">이메일</th>
            <th scope="col">클래스코드</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(users)
            .filter(
              ([uid, user]) =>
                cCodes.filter(code => code === user.currentClass).length === 0
            )
            .sort()
            .map(([uid, user], idx) => (
              <tr key={idx}>
                <th scope="row">{idx + 1}</th>
                <td>{user.name}</td>
                <td>{user.email || "n/a"}</td>
                <td className="d-flex align-items-center">
                  {user.currentClass}
                  <ModifyCCode uid={uid} cCodeDefault={user.currentClass} />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };

  render() {
    const { showStranger } = this.state;
    return (
      <>
        <div className="row mt-5">
          <div className="col-12">
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div
              className={`badge badge-${
                showStranger ? "primary" : "secondary"
              } pointer`}
              onClick={this.toggleStranger}
            >
              외부인 명단 {showStranger ? "가리기" : "보기"}
            </div>
          </div>
        </div>
        {showStranger && (
          <div className="row">
            <div className="col-12">
              <this.renderRow />
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users,
  cCodes: state.classCodes
});

export default connect(mapStateToProps)(Stranger);
